import PropTypes from 'prop-types';
import React from 'react';
import { Link, withRouter } from 'react-router';
import classnames from 'classnames';
import { stepShape } from '../shapes';

const Step = ({ step, router, disabled, className }) => {
  const isActive = router.isActive(step.url, true);
  const classNames = classnames(
    'c-breadcrumbs__item',
    {
      'is-active': isActive,
      'is-disabled': disabled,
    },
    className
  );

  return (
    <li className={classNames}>
      <Link
        to={step.url}
        tabIndex={disabled ? -1 : 0}
        className={step.trim ? 'u-text-trim u-mw-160 u-inline-block' : ''}
      >
        { step.text }
      </Link>
    </li>
  );
};
Step.propTypes = {
  step: stepShape.isRequired,
  router: PropTypes.shape({
    isActive: PropTypes.func.isRequired,
  }).isRequired,
  disabled: PropTypes.bool,
  className: PropTypes.string,
};
Step.defaultProps = {
  to: null,
  trim: false,
  disabled: false,
  className: '',
};

export default withRouter(Step);



// WEBPACK FOOTER //
// ./src/app/components/Step.jsx